<template>
  <Toast />
  <LoadingSpinner :visible="isLoading && !showInitialSplash" />
  <NotFound v-if="is404Page" />
  <InitialSplashScreen
    v-if="showInitialSplash"
    @splash-completed="handleSplashCompleted"
  />
  <div v-else :class="layoutContainerClass">
    <!-- Desktop Sidebar - always visible and outside the main flow -->
    <div
      class="sidebar-wrapper"
      v-if="this.loggedIn != null && !mobileWidth"
      :class="{ 'sidebar-collapsed': !menuActive }"
    >
      <div class="sidebar-container" @click="onMenuClick">
        <div class="sidebar-header">
          <div class="logo-container w-100" v-if="menuActive">
            <router-link :to="{ name: 'jobOpenings' }" class="logo-link">
              <img loading="lazy" src="/img/logo.svg" alt="CrowdHrs" class="logo-img" />
            </router-link>
            <button class="sidebar-toggle" @click.stop="menuActive = false">
              <i class="pi pi-chevron-left"></i>
            </button>
          </div>
          <div class="logo-small w-100" v-if="!menuActive">
            <router-link :to="{ name: 'jobOpenings' }" class="logo-link">
              <img loading="lazy" src="/img/logo_y.svg" alt="CrowdHrs" class="logo-img-small" />
            </router-link>
            <button class="sidebar-toggle" @click.stop="menuActive = true">
              <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </div>

        <div class="sidebar-content">
          <AppMenu
            :model="menu"
            inlineMenuKey="top"
            :menuMode="menuMode"
            v-model:activeMenu="menuItems"
            :active="menuActive"
            :mobileMenuActive="mobileMenuActive"
            :isSlimOrHorItemClick="isSlimOrHorItemClick"
            @change-appmenu="onChangeMenuItems"
            @menuitem-click="onMenuItemClick"
            @root-menuitem-click="onRootMenuItemClick"
          ></AppMenu>
        </div>

        <div class="sidebar-footer">
          <button class="sidebar-logout-btn" @click="logoutUser()">
            <i class="pi pi-power-off"></i>
            <span v-if="menuActive">{{ $t('logout') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile sidebar overlay -->
    <div
      class="sidebar-mobile"
      v-if="this.loggedIn != null && mobileWidth"
      :class="{ 'sidebar-mobile-active': menuActive }"
    >
      <div class="sidebar-container" @click="onMenuClick">
        <div class="sidebar-header">
          <div class="logo-container w-100">
            <router-link :to="{ name: 'chrs' }" class="logo-link">
              <img loading="lazy" src="/img/logo.svg" alt="CrowdHrs" class="logo-img" />
            </router-link>
            <button class="sidebar-close" @click.stop="ChangeMobileMenu">
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>

        <div class="sidebar-content">
          <AppMenu
            :mobileWidth="mobileWidth"
            :model="menu"
            inlineMenuKey="top"
            :menuMode="menuMode"
            v-model:activeMenu="menuItems"
            :active="menuActive"
            :mobileMenuActive="mobileMenuActive"
            :isSlimOrHorItemClick="isSlimOrHorItemClick"
            @change-appmenu="onChangeMenuItems"
            @menuitem-click="onMenuItemClick"
            @root-menuitem-click="onRootMenuItemClick"
          ></AppMenu>
        </div>

        <div class="sidebar-footer">
          <button class="sidebar-logout-btn" @click="logoutUser()">
            <i class="pi pi-power-off"></i>
            <span>{{ $t('logout') }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Main content area with topbar and content -->
    <div class="main-area" :class="{ 'with-collapsed-sidebar': !menuActive, 'with-mobile': mobileWidth }">
      <AppTopBar
        v-if="this.loggedIn != null"
        :mobileWidth="mobileWidth"
        :horizontal="menuMode === 'horizontal'"
        @TopbarMobileMenu="updateMobileMenu($event)"
        :topbarMenuActive="topbarMenuActive"
        :activeTopbarItem="activeTopbarItem"
        :mobileTopbarActive="mobileTopbarActive"
        @topbar-mobileactive="onTopbarMobileButtonClick"
        @menubutton-click="onMenuButtonClick"
        @topbar-menubutton-click="onTopbarMenuButtonClick"
        @topbaritem-click="onTopbarItemClick"
        @rightpanel-button-click="onRightPanelButtonClick"
        :searchActive="searchActive"
        @search-toggle="onSearchToggle"
        @search-click="onSearchClick"
        @search-hide="onSearchHide"
        :mobileMenu="mobileMenu"
        :mobileMenuActive="mobileMenuActive"
        @TopbarMobileMenuActive="updateMobileMenuActive($event)"
        :ondocumentclick="onDocumentClick"
      ></AppTopBar>

      <div class="main-container" v-if="this.loggedIn != null">
        <div class="layout-content">
          <!-- System messages -->
         
          <div class="content-container">
           
            <div class="content-body">
              
              
              <div class="router-view-container">
                <div class="system-messages" v-if="account.userParam?.general_check1_message && !hasSeenGeneralCheck1 || account.userParam?.general_check2_message && !hasSeenGeneralCheck2 || account.userParam?.billing_check1_message && !hasSeenBillingCheck1">
            <div class="custom-message warning-message" v-if="account.userParam?.general_check1_message && !hasSeenGeneralCheck1">
              <div class="message-icon-container">
                <i class="pi pi-exclamation-triangle"></i>
              </div>
              <div class="message-content-container">
                <p v-html="account.userParam.general_check1_message"></p>
              </div>
              <button class="message-close-btn" @click="markMessageAsSeen('general_check1')">
                <i class="pi pi-times"></i>
              </button>
            </div>
            
            <div class="custom-message warning-message" v-if="account.userParam?.general_check2_message && !hasSeenGeneralCheck2">
              <div class="message-icon-container">
                <i class="pi pi-exclamation-triangle"></i>
              </div>
              <div class="message-content-container">
                <p v-html="account.userParam.general_check2_message"></p>
              </div>
              <button class="message-close-btn" @click="markMessageAsSeen('general_check2')">
                <i class="pi pi-times"></i>
              </button>
            </div>
            
            <div class="custom-message warning-message" v-if="account.userParam?.billing_check1_message && !hasSeenBillingCheck1">
              <div class="message-icon-container">
                <i class="pi pi-exclamation-triangle"></i>
              </div>
              <div class="message-content-container">
                <p v-html="account.userParam.billing_check1_message"></p>
              </div>
              <button class="message-close-btn" @click="markMessageAsSeen('billing_check1')">
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>
                <div class="content-header-wrapper">
                <div class="content-back-button-container" v-if="$route.meta.showBackButton !== false">
                  <button class="modern-back-button" @click="$router.go(-1)" aria-label="Go back">
                    <i class="pi pi-arrow-left"></i>
                  </button>
                </div>
              </div>
                <router-view :key="$route.path" />
              </div>
            </div>
          </div>
        </div>

        <AppFooter :layoutMode="layoutMode" />
      </div>
    </div>

    <AppConfig
      :menuMode="menuMode"
      @menu-mode-change="onMenuModeChange"
      @layout-mode-change="onLayoutModeChange"
      @menu-theme="onMenuTheme"
      :layoutMode="d_layoutMode"
      @topbar-theme="onTopbarThemeChange"
      v-model:inlineMenuPosition="inlineMenuPosition"
      @inlinemenu-change="onInlineMenuPositionChange"
      :theme="theme"
      :themes="themes"
      @theme-change="changeTheme"
      :menuTheme="d_menuTheme"
      :menuThemes="menuThemes"
      :topbarTheme="d_topbarTheme"
      :topbarThemes="topbarThemes"
      :login="loggedIn"
    ></AppConfig>

    <AppRightPanel
      :expanded="rightPanelActive"
      @content-click="onRightPanelClick"
      @hide="onHideClick"
    ></AppRightPanel>
    
    <div v-if="this.loggedIn != null && (menuActive && mobileWidth)" class="layout-overlay" @click="ChangeMobileMenu"></div>
  </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue'
// import AppInlineMenu from "./AppInlineMenu.vue";
import AppRightPanel from './AppRightPanel.vue'
import AppMenu from './AppMenu.vue'
import AppConfig from './AppConfig.vue'
import AppFooter from './AppFooter.vue'
//import AppBreadcrumb from './AppBreadcrumb.vue';
import EventBus from './event-bus'
import { getItem, setItem } from './store/localStorage'
import { removeItem } from './store/localStorage'
import { get, post } from './api/Services'
import { account } from './store/account.module'
//import Search from './components/Search.vue';
import { mapState } from 'vuex'
import NotFound from './pages/NotFound.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'
import { loadingEventBus } from './router'
import InitialSplashScreen from './components/InitialSplashScreen.vue'

export default {
  emits: [
    'layout-mode-change',
    'menu-theme',
    'menuTheme',
    'topbar-theme',
    'topbarTheme',
    'layoutModeChange',
  ],
  props: {
    topbarTheme: String,
    menuTheme: String,
    layoutMode: String,
  },
  data() {
    return {
      window: {
        width: 0,
      },
      once: false,
      mobileMenu: false,
      mobileWidth: false,
      loggedIn: JSON.parse(getItem('loggeduser')),
      d_topbarTheme: this.topbarTheme,
      d_menuTheme: this.menuTheme,
      d_layoutMode: this.layoutMode,
      mobileTopbarActive: false,
      mobileMenuActive: false,
      search: false,
      searchClick: false,
      searchActive: false,
      menuMode: 'static',
      inlineMenuClick: false,
      inlineMenuPosition: 'top',
      inlineMenuTopActive: false,
      inlineMenuBottomActive: false,
      overlayMenuActive: false,
      rotateMenuButton: false,
      topbarMenuActive: false,
      activeTopbarItem: null,
      isSlimOrHorItemClick: true,
      darkMenu: false,
      theme: 'yellow',
      timeoutId: null,
      sysParam: null,
      timeoutTime: null,
      themes: [
        { name: 'indigo', color: '#2f8ee5' },
        { name: 'pink', color: '#E91E63' },
        { name: 'purple', color: '#9C27B0' },
        { name: 'deeppurple', color: '#673AB7' },
        { name: 'blue', color: '#2196F3' },
        { name: 'lightblue', color: '#03A9F4' },
        { name: 'cyan', color: '#00BCD4' },
        { name: 'teal', color: '#009688' },
        { name: 'green', color: '#4CAF50' },
        { name: 'lightgreen', color: '#8BC34A' },
        { name: 'lime', color: '#CDDC39' },
        { name: 'yellow', color: '#FFEB3B' },
        { name: 'amber', color: '#FFC107' },
        { name: 'orange', color: '#FF9800' },
        { name: 'deeporange', color: '#FF5722' },
        { name: 'brown', color: '#795548' },
        { name: 'bluegrey', color: '#607D8B' },
      ],
      menuThemes: [
        { name: 'light', color: '#FDFEFF' },
        { name: 'dark', color: '#434B54' },
        { name: 'indigo', color: '#1A237E' },
        { name: 'bluegrey', color: '#37474F' },
        { name: 'brown', color: '#4E342E' },
        { name: 'cyan', color: '#006064' },
        { name: 'green', color: '#2E7D32' },
        { name: 'deeppurple', color: '#4527A0' },
        { name: 'deeporange', color: '#BF360C' },
        { name: 'pink', color: '#880E4F' },
        { name: 'purple', color: '#6A1B9A' },
        { name: 'teal', color: '#00695C' },
      ],
      topbarThemes: [
        { name: 'lightblue', color: '#2E88FF' },
        { name: 'dark', color: '#363636' },
        { name: 'white', color: '#FDFEFF' },
        { name: 'blue', color: '#1565C0' },
        { name: 'deeppurple', color: '#4527A0' },
        { name: 'purple', color: '#6A1B9A' },
        { name: 'pink', color: '#AD1457' },
        { name: 'cyan', color: '#0097A7' },
        { name: 'teal', color: '#00796B' },
        { name: 'green', color: '#43A047' },
        { name: 'lightgreen', color: '#689F38' },
        { name: 'lime', color: '#AFB42B' },
        { name: 'yellow', color: '#FBC02D' },
        { name: 'amber', color: '#FFA000' },
        { name: 'orange', color: '#FB8C00' },
        { name: 'deeporange', color: '#D84315' },
        { name: 'brown', color: '#5D4037' },
        { name: 'grey', color: '#616161' },
        { name: 'bluegrey', color: '#546E7A' },
        { name: 'indigo', color: '#3F51B5' },
      ],
      rightPanelActive: true,
      menuActive: true,
      menuItems: false,
      menu: getItem('menu'),
      canGoBack: false,
      menuparam: null,
      userRoles: [],
      menuLoader: true,
      hasSeenGeneralCheck1: false,
      hasSeenGeneralCheck2: false,
      hasSeenBillingCheck1: false,
      isLoading: false,
      showInitialSplash: false,
      routeListener: null,
    }
  },

  watch: {
    // Diğer reactive değişkenlerin izlenmesi
    topbarTheme: {
      handler(newValue) {
        this.d_topbarTheme = newValue
      },
      immediate: true, // İlk başta hemen tetiklenmesi için
    },

    menuTheme: {
      handler(newValue) {
        this.d_menuTheme = newValue
      },
      immediate: true,
    },

    layoutMode: {
      handler(newValue) {
        this.d_layoutMode = newValue
      },
      immediate: true,
    },

    'account.loggeduser': {
      handler(newValue) {
        if (newValue) {
          this.checkSeenMessages()
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getUserMenu() {
      var params = {}
      let parameters = []
      // params.userId = this.account.loggeduser.id
      params.sqlId = 27
      parameters = [
        // {"parameter_name":"pin_user_id","parameter_value":this.account.loggeduser.id},
      ]
      params.parameters = JSON.stringify(parameters)

      // let stringUser=JSON.stringify(this.user);
      await post('Commons/Executer', params)
        .then((data) => {
          if (data) {
            this.menuparam = data
            setItem('userMenu', data)
            this.menuSet()
          }
        })
        .finally(() => {
          this.menuLoader = false
          setItem('menuLoader', this.menuLoader)
        })
    },
    menuSet() {
      this.menu = []

      this.menuparam.forEach((each) => {
        let menuObj = {
          id: each.id,
          label: each.name,
          title: each.description,
          src: `${each.icon_name}.svg`,
          activeSrc: `${each.icon_name}.active.svg`,
          to: each.name === 'Definitions' ? '' : each.link,
          auth_code: each.link || '/',
          select: each.select,
          delete: each.delete,
          insert: each.insert,
          update: each.update,
          items: [],
        }

        if (each.parent_id != null) {
          const parentMenu = this.menu.find((menu) => menu.id == each.parent_id)
          const itemsObject = {
            label: each.name,
            title: each.description,
            src: `${each.icon_name}.svg`,
            activeSrc: `${each.icon_name}.active.svg`,
            to: each.link,
            auth_code: each.link,
            select: each.select,
            delete: each.delete,
            insert: each.insert,
            update: each.update,
          }

          if (parentMenu) {
            parentMenu.items.push(itemsObject)
          } else {
            menuObj.items.push(itemsObject)
          }
        } else {
          this.menu.push(menuObj)
        }
      })
    },

    oldmenuSet() {
      this.menu = []
      let menuObj = {}
      menuObj.items = []
      let itemsObject = {}

      this.menuparam.map((each) => {
        if (each.parent_id != null) {
          if (menuObj.id == each.parent_id) {
            menuObj.items ? '' : (menuObj.items = [])
            itemsObject = {}
            itemsObject.label = each.name
            itemsObject.title = each.description
            itemsObject.src = each.icon_name + '.svg'
            itemsObject.activeSrc = each.icon_name + '.active.svg'
            itemsObject.to = each.link
            itemsObject.auth_code = each.link
            itemsObject.select = each.select
            itemsObject.delete = each.delete
            itemsObject.insert = each.insert
            itemsObject.update = each.update
            menuObj.items.push(itemsObject)
          } else {
            menuObj.items = []
            itemsObject.label = each.name
            itemsObject.title = each.description
            itemsObject.src = each.icon_name + '.svg'
            itemsObject.activeSrc = each.icon_name + '.active.svg'
            itemsObject.to = each.link
            itemsObject.auth_code = each.link
            itemsObject.select = each.select
            itemsObject.delete = each.delete
            itemsObject.insert = each.insert
            itemsObject.update = each.update
            menuObj.items.push(itemsObject)
          }
        } else {
          menuObj = {}
          menuObj.id = each.id
          menuObj.label = each.name
          menuObj.title = each.description
          each.name == 'Definitions'
            ? (menuObj.to = '')
            : (menuObj.to = each.link)
          menuObj.src = each.icon_name + '.svg'
          menuObj.activeSrc = each.icon_name + '.active.svg'
          menuObj.auth_code = '/'
          menuObj.select = each.select
          menuObj.delete = each.delete
          menuObj.insert = each.insert
          menuObj.update = each.update
          this.menu.push(menuObj)
        }
      })
    },
    ChangeMobileMenu() {
      if (this.mobileWidth) {
        // Toggle mobile sidebar
        this.menuActive = !this.menuActive;
        this.mobileMenuActive = this.menuActive;
        
        // Toggle body scroll lock - but only for small screens, not tablets
        if (this.window.width < 577) {
          if (this.menuActive) {
            document.body.classList.add('sidebar-visible');
            document.body.style.overflow = 'hidden'; // Prevent background scrolling
          } else {
            document.body.classList.remove('sidebar-visible');
            document.body.style.overflow = ''; // Allow scrolling again
          }
        } else {
          // For tablets, don't block scrolling when menu is open
          document.body.style.overflow = '';
        }
      } else {
        this.menuActive = false;
        this.mobileMenuActive = false;
        document.body.classList.remove('sidebar-visible');
        document.body.style.overflow = '';
      }
    },

    handleResize() {
      this.window.width = window.innerWidth
      if (this.window.width <= 991) {
        this.mobileWidth = true
        this.mobileMenu = true
        
        // Tablet optimization (577px - 991px)
        if (this.window.width >= 577 && this.window.width <= 991) {
          // For tablets, we still want the sidebar to be toggleable but not take full screen
          document.body.classList.remove('sidebar-visible')
          document.body.style.overflow = ''
        } 
        // Small mobile screens behavior (< 577px)
        else if (this.menuActive && this.window.width < 577) {
          document.body.classList.add('sidebar-visible')
          document.body.style.overflow = 'hidden'
        } else {
          document.body.classList.remove('sidebar-visible')
          document.body.style.overflow = ''
        }
      } else {
        this.mobileMenu = false
        this.mobileWidth = false
        
        // Ensure sidebar is visible in desktop view by default
        if (!this.once) {
          this.menuActive = true
          this.once = true
        }
        
        document.body.classList.remove('sidebar-visible')
        document.body.style.overflow = ''
      }
    },
    onDocumentClick() {
      // Eğer sidebar açıksa, click olayı sidebar veya içeriğinde olmadığında kapat
      if (this.menuActive && this.mobileWidth && !this.menuClick) {
        this.ChangeMobileMenu();
        return;
      }
      
      if (!this.searchClick && this.searchActive) {
        this.onSearchHide();
      }

      if (!this.topbarItemClick) {
        this.activeTopbarItem = null;
        this.topbarMenuActive = false;
      }

      if (!this.menuClick) {
        if (this.isHorizontal() || this.isStatic()) {
          this.isSlimOrHorItemClick = false;
          EventBus.emit('reset-active-index');
        }

        this.hideOverlayMenu();
        this.unblockBodyScroll();
      }

      if (!this.rightPanelClick) {
        this.rightPanelActive = false;
      }

      if (!this.inlineMenuClick) {
        this.inlineMenuTopActive = false;
        this.inlineMenuBottomActive = false;
      }

      this.topbarItemClick = false;
      this.menuClick = false;
      this.rightPanelClick = false;
      this.searchClick = false;
      this.inlineMenuClick = false;
    },
    onSearchToggle() {
      this.searchActive = !this.searchActive
      this.searchClick = true
    },
    onSearchClick() {
      this.searchClick = true
    },
    onSearchHide() {
      this.searchActive = false
      this.searchClick = false
    },
    isHorizontal() {
      return this.menuMode === 'horizontal'
    },
    isSlim() {
      return this.menuMode === 'slim'
    },
    isOverlay() {
      return this.menuMode === 'overlay'
    },
    isStatic() {
      return this.menuMode === 'static'
    },
    isDesktop() {
      return window.innerWidth > 991
    },
    isMobile() {
      return window.innerWidth <= 991
    },
    hideOverlayMenu() {
      this.rotateMenuButton = false
      this.overlayMenuActive = false
      this.mobileMenuActive = false
    },
    onMenuButtonClick(event) {
      this.menuClick = true
      
      if (this.mobileWidth) {
        // Handle mobile sidebar
        this.menuActive = !this.menuActive
        this.mobileMenuActive = this.menuActive
        
        // Toggle body scroll lock - but only for small screens, not tablets
        if (this.window.width < 577) {
          if (this.menuActive) {
            document.body.classList.add('sidebar-visible')
            document.body.style.overflow = 'hidden' // Prevent background scrolling
          } else {
            document.body.classList.remove('sidebar-visible')
            document.body.style.overflow = '' // Allow scrolling again
          }
        } else {
          // For tablets, don't block scrolling when menu is open
          document.body.style.overflow = ''
        }
      } else {
        // Handle desktop sidebar (toggle between slim and full)
        this.menuActive = !this.menuActive
      }
      
      event.preventDefault()
    },
    onTopbarMenuButtonClick(event) {
      this.topbarItemClick = true
      this.topbarMenuActive = !this.topbarMenuActive
      this.hideOverlayMenu()
      event.preventDefault()
    },
    onTopbarItemClick(event) {
      this.topbarItemClick = true

      if (this.activeTopbarItem === event.item) this.activeTopbarItem = null
      else this.activeTopbarItem = event.item

      event.originalEvent.preventDefault()
    },
    onTopbarMobileButtonClick(event) {
      this.mobileTopbarActive = !this.mobileTopbarActive
      event.preventDefault()
    },
    onRightPanelButtonClick(event) {
      this.rightPanelClick = true
      this.rightPanelActive = !this.rightPanelActive

      event.preventDefault()
    },
    onRightPanelClick() {
      this.rightPanelClick = true
    },
    onHideClick(expanded) {
      this.rightPanelActive = expanded
    },
    onMenuClick() {
      this.menuClick = true
    },
    onRootMenuItemClick(event) {
      if (this.mobileWidth && this.menuActive) {
        // Close mobile sidebar after clicking on menu item (for better UX)
        setTimeout(() => {
          this.menuActive = false
          this.mobileMenuActive = false
          document.querySelector('.sidebar-wrapper')?.classList.remove('active-sidebar')
        }, 300)
      }
      
      if (event.isSameIndex) {
        this.isSlimOrHorItemClick = false
      } else {
        this.isSlimOrHorItemClick = true
      }
    },
    onMenuItemClick(event) {
      if (!event.item.items) {
        this.isSlimOrHorItemClick = false
        
        if (this.mobileWidth) {
          // For tablets (577px - 991px), we want a slightly different behavior
          if (this.window.width >= 577) {
            // On tablets, close the menu with a longer delay for better UX
            setTimeout(() => {
              this.menuActive = false
              this.mobileMenuActive = false
            }, 400)
          } else {
            // For smaller mobile screens, close immediately
            setTimeout(() => {
              this.menuActive = false
              this.mobileMenuActive = false
              document.querySelector('.sidebar-wrapper')?.classList.remove('active-sidebar')
            }, 300)
          }
        }
        
        this.hideOverlayMenu()
        EventBus.emit("reset-active-index")
      }
    },
    onLayoutModeChange(menuColor) {
      this.$emit('layout-mode-change', menuColor)

      const layoutLink = document.getElementById('layout-css')
      const layoutHref = 'assets/layout/css/layout-' + menuColor + '.css'
      this.replaceLink(layoutLink, layoutHref)

      const themeLink = document.getElementById('theme-css')
      const urlTokens = themeLink.getAttribute('href').split('/')
      urlTokens[urlTokens.length - 1] = 'theme-' + menuColor + '.css'
      const newURL = urlTokens.join('/')

      this.replaceLink(themeLink, newURL, () => {
        this.$appState.isNewThemeLoaded = true
      })
    },
    onInlineMenuPositionChange(position) {
      this.inlineMenuPosition = position
    },
    onChangeInlineMenu(e, key) {
      if (key === 'top') {
        if (this.inlineMenuBottomActive) {
          this.inlineMenuBottomActive = false
        }
        this.inlineMenuTopActive = !this.inlineMenuTopActive
      }
      if (key === 'bottom') {
        if (this.inlineMenuTopActive) {
          this.inlineMenuTopActive = false
        }
        this.inlineMenuBottomActive = !this.inlineMenuBottomActive
      }

      this.inlineMenuClick = true
    },
    onChangeMenuItems(e, key) {
      if (key === 'top') {
        if (!this.menuItems) {
          this.menuItems = e
        } else {
          this.menuItems = !e
        }
      }
      if (key === 'bottom') {
        if (!this.menuItems) {
          this.menuItems = e
        } else {
          this.menuItems = !e
        }
      }

      // this.inlineMenuClick = true;
    },
    changeTheme(theme) {
      this.theme = theme
      this.changeStyleSheetUrl('theme-css', theme)
    },
    onTopbarThemeChange(theme) {
      this.$emit('topbar-theme', theme)
    },
    onMenuTheme(menuTheme) {
      this.$emit('menu-theme', menuTheme)
    },
    changeStyleSheetUrl(id, value) {
      const element = document.getElementById(id)
      const urlTokens = element.getAttribute('href').split('/')
      urlTokens[urlTokens.length - 2] = value
      const newURL = urlTokens.join('/')
      this.replaceLink(element, newURL)
    },
    replaceLink(linkElement, href, callback) {
      const id = linkElement.getAttribute('id')
      const cloneLinkElement = linkElement.cloneNode(true)

      cloneLinkElement.setAttribute('href', href)
      cloneLinkElement.setAttribute('id', id + '-clone')

      linkElement.parentNode.insertBefore(
        cloneLinkElement,
        linkElement.nextSibling
      )

      cloneLinkElement.addEventListener('load', () => {
        linkElement.remove()
        cloneLinkElement.setAttribute('id', id)

        if (callback) {
          callback()
        }
      })
    },
    blockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.add('blocked-scroll')
      } else {
        document.body.className += ' blocked-scroll'
      }
    },
    unblockBodyScroll() {
      if (document.body.classList) {
        document.body.classList.remove('blocked-scroll')
      } else {
        document.body.className = document.body.className.replace(
          new RegExp(
            '(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)',
            'gi'
          ),
          ' '
        )
      }
    },
    logoutUser() {
      try {
        // First dispatch the logout action and wait for it to complete
        this.$store.dispatch('account/logout').then(() => {
          // Clear message-related localStorage items
          if (account.state.loggeduser != null) {
            const userId = account.state.loggeduser.id

            localStorage.removeItem(`seen_message_general_check1_${userId}`)
            localStorage.removeItem(`seen_message_general_check2_${userId}`)
            localStorage.removeItem(`seen_message_billing_check1_${userId}`)

            // Reset the seen flags
            this.hasSeenGeneralCheck1 = false
            this.hasSeenGeneralCheck2 = false
            this.hasSeenBillingCheck1 = false
          }

          // Navigate to login page
          this.$router.push({ name: 'login' })
        })
      } catch (error) {
        console.error('Error during logout:', error)
        // Force navigation to login page even if there was an error
        this.$router.push({ name: 'login' })
      }
    },

    handleInactive() {
      if (account.state.loggeduser != null) {
        // Here you want to logout a user and/or ping your token
        this.logoutUser()
        account.state.loggeduser = null
      }
    },

    startTimer() {
      if (account.state.loggeduser != null) {
        //   &&
        //   this.sysParam != null &&
        //   this.sysParam.logouttime != null
        // )
        const timeoutInMS =
          // this.sysParam.logouttime *
          60000
        // setTimeout returns an ID (can be used to start or clear a timer)
        this.timeoutId = setTimeout(this.handleInactive, timeoutInMS)
      }
    },

    resetTimer() {
      if (account.state.loggeduser != null) {
        clearTimeout(this.timeoutId)
        this.startTimer()
      }
    },
    setupTimers() {
      if (account.state.loggeduser != null) {
        document.addEventListener('keypress', this.resetTimer, false)
        document.addEventListener('mousemove', this.resetTimer, false)
        document.addEventListener('mousedown', this.resetTimer, false)
        document.addEventListener('touchmove', this.resetTimer, false)

        this.startTimer()
      }
    },

    markMessageAsSeen(messageType) {
      const userId = this.account.loggeduser?.id
      if (!userId) return

      const key = `seen_message_${messageType}_${userId}`
      localStorage.setItem(key, 'true')

      switch (messageType) {
        case 'general_check1':
          this.hasSeenGeneralCheck1 = true
          break
        case 'general_check2':
          this.hasSeenGeneralCheck2 = true
          break
        case 'billing_check1':
          this.hasSeenBillingCheck1 = true
          break
      }
    },

    checkSeenMessages() {
      const userId = this.account.loggeduser?.id
      if (!userId) return

      this.hasSeenGeneralCheck1 =
        localStorage.getItem(`seen_message_general_check1_${userId}`) === 'true'
      this.hasSeenGeneralCheck2 =
        localStorage.getItem(`seen_message_general_check2_${userId}`) === 'true'
      this.hasSeenBillingCheck1 =
        localStorage.getItem(`seen_message_billing_check1_${userId}`) === 'true'
    },

    handleSplashCompleted() {
      this.showInitialSplash = false
    },
  },
  computed: {
    is404Page() {
      return this.$route.name === 'notFound' // 404 sayfası 'notFound' adıyla tanımlandıysa
    },
    layoutContainerClass() {
      return [
        'layout-wrapper',
        'layout-menu-' + this.menuTheme + ' layout-topbar-' + this.topbarTheme,
        {
          'layout-menu-static': this.menuMode === 'static',
          'layout-menu-overlay': this.menuMode === 'overlay',
          'layout-menu-overlay-active': this.overlayMenuActive,
          'layout-menu-slim': this.menuMode === 'slim',
          'layout-menu-horizontal': this.menuMode === 'horizontal',
          'layout-menu-active': this.menuActive,
          'layout-menu-mobile-active': this.mobileMenuActive,
          'layout-topbar-mobile-active': this.mobileTopbarActive,
          'layout-rightmenu-active': this.rightPanelActive,
          'layout-rtl': this.$appState.RTL,
          'p-input-filled': this.$appState.inputStyle === 'filled',
          'p-ripple-disabled': this.$primevue.config.ripple === false,
        },
      ]
    },
    ...mapState({
      account: (state) => state.account,
    }),
  },
  components: {
    AppTopBar: AppTopBar,
    NotFound: NotFound,
    AppRightPanel: AppRightPanel,
    AppMenu: AppMenu,
    AppConfig: AppConfig,
    AppFooter: AppFooter,
    LoadingSpinner,
    InitialSplashScreen,
  },
  mounted() {
    if (this.mobileWidth) {
      if (!this.once) {
        this.menuActive = true
        this.once = true
        this.mobileMenuActive = true
      }
    }
    this.d_topbarTheme = 'yellow'

    // Listen for loading events with immediate response
    loadingEventBus.on('loading', (isLoading) => {
      if (!this.showInitialSplash) {
        this.isLoading = isLoading
      } else {
        this.isLoading = false
      }
    })
  },
  beforeUnmount() {
    // Clean up event listeners
    loadingEventBus.off('loading')
    // Remove router listener when component is unmounted
    if (this.routeListener) {
      this.routeListener(); // This calls the remove function returned by beforeEach
    }
  },
  async created() {
    setItem('menuLoader', this.menuLoader)
    if (this.account.loggeduser) {
      await this.getUserMenu()
    }
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.checkSeenMessages()
    // Splash screen'i başlangıçta göster
    if (this.account.userParam) {
      this.showInitialSplash = true
    } else {
      this.showInitialSplash = false
    }
    // Add route change listener to close mobile sidebar when navigating
    this.routeListener = this.$router.beforeEach((to, from, next) => {
      if (this.mobileWidth && this.menuActive) {
        this.menuActive = false;
        this.mobileMenuActive = false;
        document.body.classList.remove('sidebar-visible');
        document.body.style.overflow = '';
      }
      next();
    });
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style lang="scss">
/* Global mobile overflow fixes */
html, body {
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

* {
  box-sizing: border-box;
}

/* Mobile specific fixes */
@media (max-width: 576px) {
  /* Sidebar specific fixes for mobile */
  .sidebar-mobile {
    width: 280px !important;
    max-width: 85% !important;
    left: -100% !important;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2) !important;
    z-index: 999 !important;
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
    transition: left 0.3s ease !important;
    background-color: #fff !important;
  }
  
  .sidebar-mobile.sidebar-mobile-active {
    left: 0 !important;
  }
  
  .sidebar-container {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }
  
  .layout-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
    z-index: 1090 !important;
    visibility: visible !important;
    opacity: 1 !important;
    transition: opacity 0.3s ease !important;
  }
  
  body.sidebar-visible {
    overflow: hidden !important;
    position: relative !important;
  }
  
  .main-area {
    z-index: 1 !important;
    position: relative !important;
  }
  
  .content-container,
  .content-body,
  .router-view-container {
    overflow-x: hidden !important;
    width: 100% !important;
    position: relative !important;
    z-index: 1 !important;
  }
  
  .sidebar-container .sidebar-content {
    overflow-y: auto !important;
    height: calc(100vh - 120px) !important;
    padding-bottom: 20px !important;
  }
  
  .sidebar-close {
    width: 32px !important;
    height: 32px !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: rgba(0, 0, 0, 0.05) !important;
    color: #444 !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
  }
  
  .sidebar-close:hover {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }
  
  .sidebar-close i {
    font-size: 18px !important;
  }
  
  /* Fixed menu items in sidebar */
  .sidebar-menu-item,
  .p-menuitem,
  .p-menuitem-link {
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }
  
  /* Ensure sidebar content is properly sized */
.sidebar-content {
    width: 100% !important;
    overflow-x: hidden !important;
  }
  
  /* Custom scrollbar styling for sidebar */
  .sidebar-content::-webkit-scrollbar {
    width: 4px;
  background: transparent;
  }
  
  .sidebar-content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
  
  /* Layout wrapper fixes */
  .layout-wrapper,
  .layout-content,
  .content-container,
  .content-body,
  .router-view-container,
  .main-area,
  .main-container {
    width: 100% !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }
  
  /* Force all elements to respect container width */
  .p-card, 
  .p-card-body, 
  .p-card-content,
  .job-card, 
  .job-cards-container, 
  .job-cards-grid,
  .p-dialog, 
  .p-dropdown, 
  .p-multiselect,
  .p-datatable, 
  .p-datatable-wrapper,
  .p-inputtext,
  .p-calendar,
  .form-group, 
  .form-control,
  .row, 
  .col, 
  .container, 
  .container-fluid,
  .job-header-container,
  .search-input-wrapper,
  .header-actions,
  .p-button,
  .action-button,
  .main-action-buttons,
  .action-buttons {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  
  /* Fix grid for mobile */
  .p-grid {
    margin: 0 !important;
  }
  
  .p-grid > div {
    padding: 0.25rem !important;
    width: 100% !important;
  }
  
  
  /* Fix for buttons */
  .p-button-label {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  
  /* Remove padding from PrimeVue components */
  .p-component {
    border-radius: 0 !important;
  }
  
  /* Fix card styles */
  .job-card, 
  .p-card {
    border-radius: 8px !important;
    margin-bottom: 10px !important;
  }
  
  /* Reduce paddings on mobile */
  .router-view-container {
    padding: 0 !important;
  }
  
  .content-body,
  .content-container {
    padding: 0 !important;
  }
}

/* Tablet specific fixes */
@media (min-width: 577px) and (max-width: 991px) {
  /* Sidebar styles for tablets */
  .sidebar-mobile {
    width: 320px !important;
    max-width: 40% !important;
    left: -100% !important;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2) !important;
    z-index: 1100 !important;
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
    transition: left 0.3s ease !important;
    background-color: #fff !important;
  }
  
  .sidebar-mobile.sidebar-mobile-active {
    left: 0 !important;
  }
  
  /* Improve menu appearance on tablets */
  .sidebar-mobile .logo-img {
    height: 40px !important;
  }
  
  .sidebar-mobile .sidebar-content {
    padding: 15px !important;
  }
  
  .sidebar-mobile .p-menuitem-link {
    padding: 10px 15px !important;
    font-size: 15px !important;
  }
  
  /* Add subtle transition for menu items */
  .sidebar-mobile .p-menuitem {
    transition: background-color 0.2s ease !important;
  }
  
  /* Adjust overlay for tablet */
  .layout-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: rgba(0, 0, 0, 0.4) !important;
    z-index: 1090 !important;
  }
  
  /* Main area tablet adjustments */
  .main-area.with-mobile {
    width: 100% !important;
    margin-left: 0 !important; 
  }
  
  /* Ensure content is properly sized on tablets */
  .router-view-container {
    padding: 15px !important;
  }
  
  /* Fixed: Handle the job cards layout better */
  .job-cards-container {
    display: grid !important;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)) !important;
    gap: 15px !important;
  }
  
  /* Improved card layout for tablets */
  .job-card, 
  .p-card {
    border-radius: 8px !important;
    margin-bottom: 15px !important;
  }
  
  /* Adjust content container padding */
  .content-container {
    padding: 0 15px !important;
  }
  
  /* Better grid for tablets - allow 2 columns */
  .p-grid {
    display: flex !important;
    flex-wrap: wrap !important;
  }
  
  .p-grid > div {
    width: 50% !important;
    padding: 0.5rem !important;
    box-sizing: border-box !important;
  }
  
  /* Adjust top bar for tablets */
  .layout-topbar {
    position: sticky !important;
    top: 0 !important;
    z-index: 998 !important;
    width: 100% !important;
  }
  
  /* Form controls should be properly sized */
  .p-inputtext,
  .p-calendar,
  .p-dropdown,
  .p-multiselect {
    width: 100% !important;
  }
  
  /* Fix form layouts */
  .form-row {
    display: flex !important;
    flex-wrap: wrap !important;
  }
  
  .form-row > div {
    padding: 0 0.5rem !important;
    box-sizing: border-box !important;
  }
}

@import './App.scss';

/* Additional sidebar-related styling */
.sidebar-visible .layout-overlay {
  display: block !important;
  z-index: 1000;
}

/* Mobile sidebar styling */
@media (max-width: 576px) {
  /* Fixed sidebar overlay */
.layout-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
    z-index: 998 !important;
    visibility: visible !important;
    opacity: 1 !important;
    transition: opacity 0.3s ease !important;
  }
  
  /* Mobile menu links */
  .sidebar-mobile .p-menuitem-link {
    display: flex !important;
    align-items: center !important;
    padding: 0.75rem 1rem !important;
    color: var(--text-color) !important;
    border-radius: 6px !important;
    transition: background-color 0.2s !important;
    text-decoration: none !important;
    cursor: pointer !important;
    position: relative !important;
    outline: none !important;
  }
  
  .sidebar-mobile .p-menuitem-link:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
  }
  
  .sidebar-mobile .p-menuitem-link.router-link-active {
    background-color: rgba(1, 92, 172, 0.1) !important;
    color: var(--primary-color) !important;
    font-weight: 500 !important;
  }
  
  /* Fix sidebar icons */
  .sidebar-mobile .p-menuitem-icon {
    margin-right: 0.75rem !important;
    font-size: 1.25rem !important;
    color: inherit !important;
  }
  
  /* Fix submenu arrows */
  .sidebar-mobile .submenu-toggle-icon {
    font-size: 0.875rem !important;
    transition: transform 0.2s !important;
  }
  
  .sidebar-mobile .menu-active > .p-menuitem-link .submenu-toggle-icon {
    transform: rotate(90deg) !important;
  }
  
  /* Adjust submenu padding */
  .sidebar-mobile .p-submenu-list {
    margin: 0 !important;
    padding: 0 0 0 2.5rem !important;
    list-style: none !important;
  }
  
  /* Fix sidebar header and footer */
  .sidebar-mobile .sidebar-header,
  .sidebar-mobile .sidebar-footer {
    padding: 1rem !important;
    border-color: rgba(0, 0, 0, 0.06) !important;
  }
  
  /* Fix logo size */
  .sidebar-mobile .logo-img {
    max-height: 36px !important;
  }
}

@media (max-width: 576px) {
  /* Sidebar specific fixes for mobile */
  .sidebar-mobile {
    width: 280px !important;
    max-width: 85% !important;
    left: -100% !important;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2) !important;
    z-index: 999 !important;
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
    transition: left 0.3s ease !important;
    background-color: #fff !important;
  }
  
  .sidebar-mobile.sidebar-mobile-active {
    left: 0 !important;
  }
}

/* Router view container ve içerik stillerini düzenle */
.router-view-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  padding-bottom: 3rem;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

/* Scrollbar stillerini tekrar ekleyelim */
.router-view-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
}

.router-view-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.router-view-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* Firefox için scrollbar */
.router-view-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

/* Sidebar içeriğindeki li elemanlarının stillerini düzelt */
.sidebar-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.sidebar-content li {
  width: 100%;
  margin-bottom: 5px;
}

/* Tüm içerik görünür olsun diye */
.router-view-container > * {
  max-width: 100%;
  overflow-x: hidden;
}

/* Main container içindeki boşlukları azaltalım */
@media (max-width: 576px) {
  .main-container {
    padding: 0 !important;
    margin: 0 !important;
  }
  
  /* Her sayfanın kendi yeterli padding'i olsun */
  .router-view-container > * {
    padding: 10px !important;
  }
}

/* Desktop Layout Fixes */
@media (min-width: 992px) {
  .sidebar-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 280px;
    z-index: 999;
    background-color: white;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    transition: width 0.3s ease;
  }
  
  .sidebar-wrapper.sidebar-collapsed {
    width: 80px;
  }
  
  .main-area {
    margin-left: 280px;
    transition: margin-left 0.3s ease;
  }
  
  .main-area.with-collapsed-sidebar {
    margin-left: 80px;
  }
  
  .layout-topbar {
    position: sticky !important;
    top: 0;
    z-index: 998;
    width: 100%;
  }
  
  .content-back-button-container {
    margin-top: 12px;
  }
}

/* Back Button Styling */
.modern-back-button {
  width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    color:  #015cac;
    transition: all .2s ease;
}

.modern-back-button:hover {
  background-color: #d9e9fa;
}

.modern-back-button i {
  font-size: 1.25rem;
}

.content-header-wrapper {
  display: flex;
  align-items: center;
}

.content-back-button-container {
  display: flex;
  align-items: center;
}

/* Sidebar Back Button */
.sidebar-header .back-button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
  color: #444;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sidebar-header .back-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.sidebar-header .back-button i {
    font-size: 14px;
  }
  
.sidebar-toggle {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background-color: transparent;
  color: #444;
    display: flex;
    align-items: center;
    justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sidebar-toggle:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.sidebar-toggle i {
  font-size: 14px;
}

.sidebar-close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background-color: rgba(0, 0, 0, 0.05);
  color: #444;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sidebar-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.sidebar-close i {
  font-size: 18px;
}

/* Sidebar Layout */
.sidebar-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.sidebar-header {
  padding-inline: 12px;
  height: 56px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.sidebar-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.sidebar-footer {
  padding: 16px;
  border-top: 1px solid #f0f0f0;
}

.logo-container, .logo-small {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-link {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 50px;
  width: auto;
}

.logo-img-small {
  height: 32px;
  width: auto;
}

.sidebar-logout-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: none;
  color: #666;
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.sidebar-logout-btn:hover {
  background: rgba(0,0,0,0.05);
}

/* Main Container Layout */
.main-container {
  min-height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
}

.layout-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.content-container {
  flex: 1;
  padding: 0 20px;
}

.content-body {
  flex: 1;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.sidebar-nav {
  overflow-y: auto;
  padding: 0 12px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  .layout-inline-menu-icon {
    font-size: 12px;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border: 0;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .ch-sidebar-item {
    position: relative;
    border-radius: 5px;
    transition: 0.3s;
    color: #42526e;
    font-family: Jost;
    font-size: 14px;
    font-weight: 600;
    width: 100%;
    text-decoration: none;
    cursor: pointer;

    .ch-item-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      flex: 1;
      min-width: 0;
    }

    &:hover,
    &.router-link-active {
      background-color: #e6effc;
      text-decoration: none;
    }

    &.router-link-active {
      .icon {
        background-color: #015cac;
      }

      .ch-item-title {
        color: #015cac;
      }
    }

    &.router-link-active::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 5px;
      height: 24px;
      border-radius: 0 2px 2px 0;
      background: #015cac;
    }
  }
  
  /* Collapsed sidebar item styles */
  .justify-content-center.router-link-active::before {
    width: 4px;
    left: 0;
    height: 60%;
  }
  
  .justify-content-center .icon {
    width: 24px;
    height: 24px;
  }
  
  .ch-sub-menu:not(.ch-sidebar-item) {
    padding-left: 20px;
    width: 100%;
    box-sizing: border-box;
  }

  .ch-sub-menu .ch-sidebar-item {
    color: #53678b;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    padding-left: 20px;
  }
}

/* Sidebar collapsed styling for active items */
.sidebar-wrapper.sidebar-collapsed {
  .sidebar-nav {
    padding: 0 6px;
    
    .ch-sidebar-item {
      padding: 10px 6px !important; 
      align-items: center;
      justify-content: center;
      height: 44px;
      margin-bottom: 4px;
      
      &:hover {
        background-color: #f0f7ff;
      }
      
      &.router-link-active {
        border-radius: 4px;
        background-color: rgba(1, 92, 172, 0.15);
      }
      
      &.router-link-active::before {
        width: 4px;
        height: 24px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 0 2px 2px 0;
      }
      
      &.router-link-active .icon {
        background-color: #015cac;
      }
      
      /* Center the icon properly */
      span {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      /* Fix icon color */
      .icon {
        width: 22px !important;
        height: 22px !important;
        background-color: #42526e;
        transition: background-color 0.2s;
      }
    }
    
    .ch-sub-menu:not(.ch-sidebar-item) {
      padding-left: 0;
    }
    
    .ch-sub-menu .ch-sidebar-item {
      padding: 10px 6px !important;
      justify-content: center;
      height: 40px;
      
      .icon {
        width: 20px !important;
        height: 20px !important;
      }
    }
  }
}

/* Ensure active state is better visible in both expanded and collapsed sidebar */
.sidebar-nav .ch-sidebar-item.router-link-active {
  background-color: rgba(1, 92, 172, 0.15);
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 24px;
    border-radius: 0 2px 2px 0;
    background: #015cac;
  }
  
  .icon {
    background-color: #015cac !important;
  }
}

/* Remove redundant styles */
.sidebar-nav .ch-sidebar-item.router-link-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  border-radius: 0 2px 2px 0;
  background: #015cac;
}

/* System Messages Styling */
.system-messages {
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-message {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  position: relative;
  gap: 12px;
}

.warning-message {
  background-color: #fef9c3;
  border-left: 4px solid #eab308;
}

.message-icon-container {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-message .message-icon-container i {
  color: #b45309;
  font-size: 18px;
}

.message-content-container {
  flex: 1;
}

.message-content-container p {
  margin: 0;
  color: #713f12;
  font-size: 14px;
  line-height: 1.5;
}

.message-close-btn {
  background: transparent;
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #92400e;
  padding: 0;
  margin-left: auto;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.message-close-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.message-close-btn i {
  font-size: 14px;
}

</style>

